import React, { useState } from "react";

function ExperiencesList() {
  const [isFtrModalOpen, setFtrModalOpen] = useState(false);

  return (
    <div className="mt-10 px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Work & Research Experience
      </h1>

      {/* Work Section */}
      <section className="mt-12 space-y-8">
        <h2 className="text-2xl text-white font-semibold">Work Experience</h2>

        <div className="text-left text-gray-300 space-y-6">
          <div>
            <h3 className="text-xl font-medium text-white">
              Marketing Coordinator & Assistant Journal Coordinator
            </h3>
            <p>
              <strong>Journal of Purdue Undergraduate Research (JPUR)</strong> —
              Develop and curate content across five channels, reaching over
              1,000 students and faculty to foster community engagement and
              drive manuscript submissions.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-medium text-white">
              Machine Learning Intern
            </h3>
            <p>
              <strong>Silicon Technologies Incorporated</strong> — Designed a
              multi-agent AI framework to automate the full analog IC design
              flow, resulting in a projected five-hour reduction in weekly
              design time per engineer. Analyzed the framework's technical and
              financial viability, evaluating deployment strategies, data
              scalability, and long-term competitive advantages.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-medium text-white">
              Electrical Engineering Intern
            </h3>
            <p>
              <strong>Action Manufacturing Company</strong> — Assembled and
              validated a custom PCB for M107 warhead armament systems to ensure
              deployment reliability through functional testing, and developed a
              systematic inspection system for MK60 gear systems and proposed
              new quality control protocols.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-medium text-white">
              Founder & Co-President
            </h3>
            <p>
              <strong>STEM Enrichment of Pennsylvania 501(c)(3)</strong> —
              Established a nonprofit dedicated to supporting STEM literacy in
              high school students by partnering with local businesses to
              broaden educational resources. Oversaw a leadership team of four
              students to run workshops and publish educational resources
              online.
            </p>
          </div>
        </div>
      </section>

      {/* Research Section */}
      <section className="mt-12 space-y-8">
        <h2 className="text-2xl text-white font-semibold">
          Research Experience
        </h2>

        <div className="text-left text-gray-300 space-y-6">
          <div>
            <h3 className="text-xl font-medium text-white">
              Undergraduate Researcher
            </h3>
            <p>
              <strong>Purdue University</strong> — Leverage multi-instrument
              datasets (including reflectance spectra, XRF elemental profiles,
              and microscopic images) to develop a binary classification model
              for counterfeit detection, optimized via Bayesian optimization.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-medium text-white">
              Undergraduate Research Fellow
            </h3>
            <p>
              <strong>Purdue University</strong> — Conducted research under Dr.
              Peter Bermel to develop a novel testing framework that qualified
              commercial microelectronics, such as the FTLX8574D3BCV multimode
              10G SFP+ optical transceiver, for space. Simulated charged
              particle interactions using SRIM/TRIM software to design a
              shielding strategy with materials like tungsten and doped
              polymers, mitigating ionizing radiation effects and reducing
              secondary interactions.
            </p>
            {/* Centered, rounded button */}
            <div
              className={`flex justify-center mt-4 ${
                isFtrModalOpen ? "hidden" : ""
              }`}
            >
              <button
                onClick={() => setFtrModalOpen(true)}
                className="
inline-flex w-full items-center justify-center rounded-md border border-transparent outline-3 outline py-3 text-base font-medium text-white shadow-sm button_slide  slide_right focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2
                "
              >
                View FTR Research Overview
              </button>
            </div>
          </div>

          {/* FTR Modal */}
          {isFtrModalOpen && (
            <div className="fixed inset-0 bg-opacity-75 flex items-center justify-center p-4">
              <div className="bg-gray-900 rounded-lg overflow-auto max-w-2xl w-full p-6 relative">
                <button
                  onClick={() => setFtrModalOpen(false)}
                  className="absolute top-2 right-2 text-white hover:text-gray-900"
                >
                  ✕
                </button>

                <h4 className="text-2xl font-semibold mb-4">
                  FTR Research Overview
                </h4>

                {/* Placeholder for your project images */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <img
                    src="./assets/research/Poster.png"
                    alt="FTR project 1"
                    className="rounded"
                  />
                  <img
                    src="./assets/research/Powerpoint.png"
                    alt="FTR project 2"
                    className="rounded"
                  />
                </div>

                <a
                  href="https://seanrk06.github.io/Radiation-Qualification-of-Commercial-Microelectronics/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mb-4 text-teal-500 hover:underline"
                >
                  Click here to view full research overview
                </a>
              </div>
            </div>
          )}

          <div>
            <h3 className="text-xl font-medium text-white">
              Research Assistant
            </h3>
            <p>
              <strong>Abington Neurological Associates</strong> — Reviewed and
              documented prodromal, aura, and headache symptoms from 400+
              patient records to identify early warning signs, contributing to a
              research paper on migraine prediction.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ExperiencesList;
